import { Component, OnDestroy, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NotificationPopup } from 'src/app/model/notificationPopUp';
import { StatusResultModalEdit } from 'src/app/shared/services/modal.service';
import { ModalNotification } from '../header/header.component';

@Component({
	selector: 'app-modal-notification',
	templateUrl: './modal-notification.component.html',
	styleUrls: ['./modal-notification.component.scss']
})
export class ModalNotificationComponent implements OnInit {

	data: ModalNotification;
	success: (resultData: ModalNotification, status: StatusResultModalEdit) => void;
	buttonDisabled = true;
	timer = 10;

	constructor(private readonly bsModalRef: BsModalRef) {
	}

	ngOnInit(): void {
		const i = setInterval(() => {
			this.timer -= 1;
			if (this.timer === 0) {
				clearInterval(i);
				this.buttonDisabled = false;
			}
		}, 1000);
	}

	close(): void {
		this.data.notification.isRead = true;
		this.success(this.data, StatusResultModalEdit.SAVE);
		this.bsModalRef.hide();
	}

}
